module.exports = {
  APP_NAME: 'nurture-bar-ui',
  FEATURE_TOGGLE: 'nurture_bar_ui',
  DISABLE_FEATURE_FLAG: 'disable_nurture_bar_ui',
  API_BASE_PATH: '/api/v2/',
  URL_STRING: 'nurture-bar-ui',
  BASE_PATH: '/',
  SEGMENT_TRACK_VERSION: 3,
  SEGMENT_WRITE_KEY: {
    production: 'FNVX8mJr5XOhm3eDlo59v0MeXIzmQC5C', // segment source: web-ui
    development: 'rnZrXQEFFa0fM1kBiZJGRCGadYkYbI7l' // segment source: web-ui-development
  },
  // Parital strings of routes that the nurture bar should not appear on
  UNALLOWED_ROUTES: [
    'app.pagerduty.com',
    'admin.pagerduty.com',
    'admin.pd-staging.com',
    'pdt-circular.pagerduty.com',
    'app.pd-staging.com',
    '/onboarding',
    '/account/settings/subscription/purchase',
    '/sign_in',
    '/forgot_password',
    '/reset_password',
  ]
};
